import { Checkbox, Button } from "@components/global";
import { fontFamilies } from "@util/constants";
import { Container, H2, P, A } from "@util/standard";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { setUserDetails, setUser } from "@util/helper";
import firebase from "firebase";
import { toast } from "react-toastify";
import auth from "@shared/auth";
import { userInfo } from "os";
import ForgotPasswordForm from "./forgotPasswordForm";
import { useStore } from "@state/store";

const Input = styled.input`
  border: none;
  border-bottom: 1px solid #000000;
  padding-bottom: 10px;
  margin-bottom: 25px;

  ::placeholder {
    font-size: 15px;
    font-family: ${fontFamilies.proximaNova};
  }

  :focus-visible {
    outline: none;
  }
`;

function LoginForm() {
  const [isSignUpForm, setIsSignUpForm] = useState(false);
  const [forgotPasswordOpen, setforgotPasswordOpen] = useState(false);
  const [stayLoggedIn, setStayLoggedIn] = useState(false);
  const { createAccountFormOpen } = useStore();
  const formDefaultState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    passwordCheck: "",
    newsLetter: false,
    stayLoggedIn: false,
  };
  const [formData, setFormData] = useState(formDefaultState);

  const signUp = () => {
    if (formData.password !== formData.passwordCheck) {
      alert("Password doesnt match");
      return;
    }

    firebase
      .auth()
      .createUserWithEmailAndPassword(formData.email, formData.password)
      .then(results => {
        if (results == null || results.user == null) {
          console.log("An error occurred while trying to sign up");
          return null;
        }

        const userData = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          name: formData.firstName + " " + formData.lastName.toString(),
          email: results.user?.email as string,
          profilePic: results.user?.photoURL as string,
          uid: results.user?.uid as string,
          newsLetter: stayLoggedIn,
        };
        setTimeout(() => {
          setUserDetails(userData);
          results.user?.updateProfile({ displayName: formData.firstName + " " + formData.lastName.toString() });
          setIsSignUpForm(false);
          setFormData(formDefaultState);
        }, 100);
        toast.success("Account Created! Please Log in");
        return;
      })
      .catch(error => console.log(error));
  };

  const login = () => {
    firebase
      .auth()
      .signInWithEmailAndPassword(formData.email, formData.password)
      .then(results => {
        if (results == null || results.user == null) {
          toast.error("An error occurred while trying to log in");
          return null;
        }
        return setUser(results.user.uid);
      })
      .catch(error => {
        toast.error("Login Error: please check that your details are correct");
      });
    return;
  };

  useEffect(() => {
    if (createAccountFormOpen) {
      setIsSignUpForm(true);
    } else {
      setIsSignUpForm(false);
    }
  }, [createAccountFormOpen]);

  return (
    <Container flexDirection="column">
      {!forgotPasswordOpen && (
        <>
          <H2 fontWeight="bold" color="darkerGreen">
            {isSignUpForm ? "Create an account" : "Log in"}
          </H2>
          <P margin="10px 0 40px 0" width="80%">
            {`To save recipes and articles and more. ${
              isSignUpForm ? "Already have an account?" : "Don’t have an account?"
            }`}
            <A margin="0 0 0 10px" underlined onClick={() => setIsSignUpForm(!isSignUpForm)}>
              {isSignUpForm ? "Log in" : "Sign Up"}
            </A>
          </P>
        </>
      )}
      {/* LOGIN FORM */}
      {!isSignUpForm && !forgotPasswordOpen && (
        <Container flexDirection="column">
          <Input
            placeholder="Email address"
            required
            onChange={e => setFormData({ ...formData, email: e.target.value })}
          />
          <Input
            placeholder="Password"
            type="password"
            required
            onChange={e => setFormData({ ...formData, password: e.target.value })}
          />
        </Container>
      )}
      {/* SIGN UP FORM*/}
      {isSignUpForm && !forgotPasswordOpen && (
        <Container flexDirection="column">
          <Input
            placeholder="First Name"
            required
            onChange={e => setFormData({ ...formData, firstName: e.target.value })}
          />
          <Input
            placeholder="Last Name"
            required
            onChange={e => setFormData({ ...formData, lastName: e.target.value })}
          />
          <Input
            type="email"
            placeholder="Email address"
            required
            onChange={e => setFormData({ ...formData, email: e.target.value })}
          />
          <Input
            type="password"
            placeholder="Password"
            required
            onChange={e => setFormData({ ...formData, password: e.target.value })}
          />
          <Input
            placeholder="Confirm Password"
            type="password"
            required
            onChange={e => setFormData({ ...formData, passwordCheck: e.target.value })}
          />
        </Container>
      )}
      {forgotPasswordOpen && (
        <Container>
          <ForgotPasswordForm setVisible={setforgotPasswordOpen} />
        </Container>
      )}
      <Container onClick={() => setStayLoggedIn(!stayLoggedIn)}>
        {isSignUpForm && !forgotPasswordOpen && (
          <>
            <Checkbox isDark checked={stayLoggedIn} /> <P margin="auto 0 auto 15px">Sign up for our newsletters</P>
          </>
        )}
        {!isSignUpForm && !forgotPasswordOpen && (
          <>
            <Checkbox isDark checked={stayLoggedIn} /> <P margin="auto 0 auto 15px">Keep me logged in</P>
          </>
        )}
      </Container>
      {!isSignUpForm && !forgotPasswordOpen && (
        <A width="max-content" margin="20px 0 0 0" underlined onClick={() => setforgotPasswordOpen(true)}>
          Forgot Password
        </A>
      )}
      {!isSignUpForm && !forgotPasswordOpen && (
        <Button theme="block" margin="40px 0" text="Log in" onClick={() => login()} />
      )}
      {isSignUpForm && !forgotPasswordOpen && (
        <Button theme="block" margin="40px 0" text="Sign up" onClick={() => signUp()} />
      )}
    </Container>
  );
}

export default LoginForm;
